export function fillMeta (data = {}) {
  const { title, description, canonical } = data;
  return {
    title,
    meta: [
      {
        hid: 'og:title',
        property: 'og:title',
        content: title,
      },
      {
        hid: 'apple-mobile-web-app-title',
        name: 'apple-mobile-web-app-title',
        content: title,
      },
      ...(description
        ? [
          {
            hid: 'description',
            name: 'description',
            content: description,
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: description,
          },
        ]
        : []),
      ...(canonical
        ? [
          {
            hid: 'og:url',
            property: 'og:url',
            content: canonical,
          },
        ]
        : []),
    ],
    ...(canonical
      ? {
        link: [{
          hid: 'canonical',
          rel: 'canonical',
          href: canonical,
        }],
      }
      : {}),
  };
};
